<svg
  [attr.height.px]="radius * 2"
  [attr.width.px]="radius * 2"
  [ngStyle]="{width: radius*2+'px', height: radius*2+'px'}"
>

  <circle
    stroke="#EBEBEB"
    [attr.stroke-width]="stroke"
    fill="transparent"
    [attr.r]="normalizedRadius"
    [attr.cx]="radius"
    [attr.cy]="radius">
  </circle>

  <circle
    stroke="#62209A"
    [attr.stroke-dasharray]="circumference + ' ' + circumference"
    [ngStyle]="{ 'strokeDashoffset': strokeDashoffset }"
    [attr.stroke-width]="stroke"
    fill="transparent"
    [attr.r]="normalizedRadius"
    [attr.cx]="radius"
    [attr.cy]="radius">
  </circle>

  <text *ngIf="progress || progress === 0"
        x="50%" [attr.y]="percentageY"
        [attr.fill]="progress === 0 ? '#E23D28' : '#62209A'"
        font-size="2em"
        font-family="sans-serif"
        text-anchor="middle"
        stroke-width="1px" dy=".1em">
    <tspan font-weight="bold">
      {{ progress }}%
    </tspan>
  </text>

  <text *ngIf="progress === null"
        x="50%" y="57%"
        fill="#3E3E3E"
        font-size="2em"
        text-anchor="middle"
        stroke-width="1px" dy=".1em">
    N/A
  </text>

  <text *ngIf="description"
        x="50%" y="65%"
        fill="#3E3E3E"
        font-size="0.8em"
        text-anchor="middle"
        stroke-width="1px" dy=".1em">
    {{ description }}
  </text>


</svg>
